import React from "react";
import { chemistryCalculators } from "./ConstantsChemistryCalculator";
import SharedHelmet from ".././Helmet";
const TITLE =
  "حواسب الكيمياء - حواسب مجانية لحساب الكتلة المولية وكتلة الحديد وكتلة الماء وحجم الغاز وحجم العينة.";
const DESCRIPTION =
  "استكشف مجموعة حواسب الكيمياء المجانية، بما في ذلك حواسب الكتل المختلفة والأحجام المختلفة للمواد.";
const KEYWORDS =
  "حاسبة كتلة الحديد، حاسبة الكتلة المولية، حاسبة كتلة الماء، حاسبة حجم الغاز، حاسبة حجم العينة";
const OG_URL = "https://do-calculate.com/ar/chemistry-calculators/";
function ChemistryList() {
  return (
    <div className="container rtl-container">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div>
        <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
        <hr />
        <div className="alert alert-secondary" role="alert">
          <p>{DESCRIPTION} </p>
        </div>
      </div>
      <hr />
      <table >
        <thead>
          <tr>
            <th >الحاسبة</th>
            <th >الوصف</th>
          </tr>
        </thead>
        <tbody>
          {chemistryCalculators.map((calculator, index) => (
            <tr key={index}>
              <td>
                <a href={calculator.link}>
                  {" "}
                  <h2 style={{ fontSize: "14px" }}>{calculator.name}</h2>{" "}
                </a>
              </td>
              <td>
                <p>{calculator.description}</p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
    </div>
  );
}
export default ChemistryList;
